import { matchPath } from "react-router";

const STATIC_PAGES = new Set(["faq", "imprint", "install", "privacy-policy"]);

export function isStaticPagePath(pathname: string) {
  const match = matchPath("/:language/:campground/:page", pathname);
  return Boolean(match?.params.page && STATIC_PAGES.has(match.params.page));
}
